"use client";
import { useTranslations } from "next-intl";
import { itemComponentMap } from "@repo/next-shared/utils/rich-translate-map";

export default function PrivacyPage() {
  const t = useTranslations("Privacy");
  return (
    <section>
      <div className="p-10">
        <h1>{t("title")}</h1>
        {t.rich("content", itemComponentMap)}
      </div>
    </section>
  );
}
